import React from "react";
import PropTypes from "prop-types";
import style from "./MenuItem.css"

function MenuItem({ hidden, onClick, children }) {
  return hidden ? null : (
    <li>
      <a style={style.menuItem} onClick={onClick}>{children}</a>
    </li>
  );
}

MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  hidden: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default MenuItem;
